import { render, staticRenderFns } from "./chat-index.vue?vue&type=template&id=4ac51fd6&scoped=true&"
import script from "./chat-index.vue?vue&type=script&lang=js&"
export * from "./chat-index.vue?vue&type=script&lang=js&"
import style0 from "./chat-index.vue?vue&type=style&index=0&id=4ac51fd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac51fd6",
  null
  
)

export default component.exports